
import { React, useState, useEffect } from "react";

import { IoIosMail } from "react-icons/io";
import { TbMessageFilled } from "react-icons/tb";
import instaImg from "../../assets/instagram.svg";
import linkedInImg from "../../assets/linked-in.svg";
import twitterImg from "../../assets/twitter.svg";
import ReCAPTCHA from "react-google-recaptcha";
import { handleError, handleSuccess } from "../../Utils";
import { getContact } from "../../ApiServices/ApiServices";

const Contact = () => {
  const REACT_APP_SITE_KEY = "6Le3Kw8rAAAAAPTAwr2sg7Y-2LLLw9gDgXT0C9bf";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading]  = useState(false);

  useEffect(() => {
    document.title = "Codequeue - Contact";
    window.scrollTo({top:'0', behavior:'smooth'})
  }, []);

  const [captchaVerified, setCaptchaVerified] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCaptcha = async (value) => {
    setCaptchaVerified(!!value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (captchaVerified) {
      try {
        const response = await getContact(formData);
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
        return handleSuccess(response?.message);
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }finally{
        setLoading(false);
      }
    } else {
      handleError("Please verify you are human!");
    }
  };

  const recaptchaWrapperStyle = {
    width: "100%", // Full width
    maxWidth: "100%", // Ensure no overflow on small screens
    margin: "0 auto", // Center it horizontally
    transform: "scale(0.85)", // Scale it down for small screens
    transformOrigin: "top center", // Ensure the scaling happens from the top
  };

  const recaptchaContainerStyle = {
    display: "flex",
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
    height: "100%", // Ensure the container takes the full height of the screen
  };

  return (
    <div className="mt-md-5 mx-md-5 mx-3 mt-sm-4 p-md-5 m-3 p-3">
      <div className="bg-gradient-to-br from-transparent to-[#FFFFE8] backdrop-blur-md rounded-2xl d-flex flex-lg-row flex-column w-100 py-5 overflow-hidden gap-5 align-items-center">
        {/* Left part */}
        <div className="col-lg-6 col-12">
          <div className="d-flex align-items-center justify-content-between w-100">
            <div>
              <h1 className="h3">Send us a message...</h1>
            </div>
            <div className="display-6">
              <TbMessageFilled />
            </div>
          </div>

          {/* User Contact Form */}
          <div className="mt-3">
            <form onSubmit={handleSubmit}>
              <div className="d-flex flex-md-row flex-column gap-md-2 gap-1">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="p-2 text-lg rounded-md border border-gray-300 w-100"
                  style={{ marginBottom: '5px' }}
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="p-2 text-lg rounded-md border border-gray-300 w-100"
                  style={{ marginBottom: '5px' }}
                />
              </div>

              <div className="d-flex flex-md-row flex-column gap-md-2 gap-1">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="p-2 text-lg rounded-md border border-gray-300 w-100"
                  style={{ marginBottom: '5px' }}
                />

                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="p-2 text-lg rounded-md border border-gray-300 w-100"
                  style={{ marginBottom: '5px' }}
                />
              </div>

              <div className="mb-3">
                <textarea
                  cols="70"
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="p-2 text-lg rounded-md border border-gray-300 h-24 resize-none w-100"
                  style={{ marginBottom: '9px' }}
                />
              </div>

              <div className="d-flex flex-md-row flex-column align-items-center mt-2 justify-content-around gap-sm-3">
                <div style={recaptchaContainerStyle}>
                  <div style={recaptchaWrapperStyle}>
                    <ReCAPTCHA
                      sitekey={REACT_APP_SITE_KEY}
                      onChange={handleCaptcha}
                      theme="light" // Optional: You can also add theme="dark"
                    />
                  </div>
                </div>
                <div className="">
                  <button
                    type="submit"
                    disabled={!captchaVerified}
                    className="py-2 px-5 text-lg text-white bg-blue-500 rounded-md cursor-pointer disabled:bg-gray-300 disabled:cursor-not-allowed"
                  >
                    {loading?"Sending...":"Send"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Right Part */}
        <div className="col-lg-6 col-12">
          <div>
            <div className="d-flex align-items-center justify-content-center w-100">
              <h1 className="h3">Contact Information</h1>
            </div>

            <div className="d-flex flex-col justify-content-center align-items-center mt-5">
              <div className="display-6">
                <IoIosMail />
              </div>
              <div>
                <a
                  href="mailto:support@codequeue.in"
                  target="_blank"
                  className="text-decoration-none"
                >
                  support@codequeue.in
                </a>
              </div>
            </div>

            {/* Social Media Links */}
            <div className="my-5 d-flex justify-content-center gap-3">
              <a href="https://www.linkedin.com/company/code-queue/?viewAsMember=true" target="_blank">
                <img src={linkedInImg} alt="linkedIn-Logo" className="img-fluid" />
              </a>
              <a href="https://www.instagram.com/codequeue.in/" target="_blank">
                <img src={instaImg} alt="insta-Logo" className="img-fluid" />
              </a>
              <a href="https://x.com/ssatyendrak13" target="_blank">
                <img src={twitterImg} alt="twitter-Logo" className="img-fluid" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;